import React from "react";
import ReactDOM from "react-dom";
// import LiveEvent from './containers/LiveEvent';
import { DataProvider } from "./DataProvider";
import Header from "./containers/Header";
import Items from "./containers/Items";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ScrollToTop from "react-scroll-to-top";
import {
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";

import { createUseStyles } from "react-jss";

const useGlobalStyle = createUseStyles({
  "@global": {
    "#app": {
      paddingTop: 64,
      "@media screen and (min-width: 992px)": {
        paddingTop: 100,
      },
      "@media screen and (min-width: 1200px)": {
        paddingTop: 152,
      },
    },
    body: {
      backgroundColor: "#353944",
    },
    ".live-board-desktop div.smart-image": {
      "& .img-container": {
        backgroundColor: "#fff",
        padding: "8px",
        height: "100%",
        borderRadius: "0.5rem",
        width: "fit-content",
        margin: "0 auto",
        "& img": {
          height: "100%",
        },
      },
    },
    // Set width for header category list
    ".live-event-header": {
      width: "auto",
      paddingTop: "2rem !important",
    },
    ".live-event-buttons": {
      display: "none",
    },
    ".board-content-container": {
      backgroundColor: "#353944 !important",
    },
    ".board-content-container .board-content>*": {
      backgroundColor: "#353944",
      padding: "0 !important",
    },
    // Set background color for promo & items area
    "div.board-content.short-banner": {
      backgroundColor: "#353944",
    },
    ".live-board-desktop": {
      minWidth: "auto",
    },
    ".live-board .live-board-mobile .promotion-items.columns-container": {
      maxWidth: "max-content",
    },

    // Reset promotion area
    ".live-board .promotion-area-container .promotion-items.columns-container":
      {
        display: "block",

        "& .promotion-item": {
          maxWidth: "max-content",
          padding: "0",

          "& p": {},
        },
      },
    ".live-board .promotion-item .promotion-item-text": {
      maxWidth: "max-content",
    },
    ".live-board .live-event-buttons .meeting-button": {
      color: "#FF8426",
      borderColor: "#FF8426",
      backgroundColor: "#353944",
    },
    ".flz-btn": {
      color: "white !important",
      borderColor: "#C93995 !important",
      backgroundColor: "#C93995 !important",
      borderRadius: "3px !important",
      marginBottom: "3rem",
    },
    ".live-event-stream-container": {
      width: "50% !important",
    },
    ".live-board .live-event-buttons .meeting-button:hover": {
      color: "#FF8426",
      borderColor: "#FF8426",
      backgroundColor: "#353944",
    },
    ".live-board .promotion-area-container .promotion-area-text": {
      margin: "0 auto 0",
    },

    // Style promo area
    ".live-board .promotion-area-container": {
      "&.promo-area-1": {
        padding: "0",
        "& .promotion-area-text": {
          "& h1": {
            color: "white",
            fontFamily: "LexendDeca-Bold",
            fontWeight: "bold",
            fontSize: "2.6rem",
            letterSpacing: "0.03em",
            lineHeight: "1.5em",
            paddingTop: "6rem",
          },
          "& p": {
            color: "#FFFFFF",
            fontFamily: "LexendDeca-Light",
            fontWeight: "normal",
            fontSize: "2rem",
            lineHeight: "1.5em",
            padding: "3rem 3rem",
          },
        },
      },
      "&.promo-area-2": {
        maxWidth: "unset",
        backgroundColor: "#bfda33",
        "& .promotion-area-text": {
          "& h1": {
            color: "#25282d",
            fontFamily: "LexendDeca-Bold",
            fontWeight: "bold",
            fontSize: "4rem",
            letterSpacing: "0.03em",
            lineHeight: "115%",
            paddingTop: "6rem",
          },
          "& hr": {
            color: "white",
            border: "none",
            height: "2px",
            backgroundColor: "white",
            width: "100px",
            marginTop: "4rem",
          },
          "& p": {
            color: "#25282d",
            fontFamily: "LexendDeca-Light",
            fontWeight: "normal",
            fontSize: "2rem",
            lineHeight: "1.5em",
            padding: "1rem 3rem 3rem 3rem",
          },
        },
      },
      "&.promo-area-3": {
        paddingBottom: "3rem !important",
        "& h1": {
          color: "#fff",
          fontFamily: "LexendDeca-Bold",
          fontWeight: "bold",
          fontSize: "2.6rem",
          letterSpacing: "0.03em",
          lineHeight: "115%",
          paddingTop: "3rem",
          marginBottom: "2rem",
        },
        "& p": {
          color: "#fff",
          fontFamily: "LexendDeca-Light",
          fontWeight: "normal",
          fontSize: "2rem",
          lineHeight: "1.5em",
          paddingBottom: "5rem",
        },

        "& .promotion-items.columns-container": {
          display: "flex",
          flexWrap: "nowrap",
          justifyContent: "start",
          width: "100%",
          overflowX: "auto",
        },

        "& .promotion-items.carousel-container .carousel .carousel-items li.promotion-item, & .promotion-items.columns-container li.promotion-item":
          {
            backgroundColor: "#353944",
            minWidth: "42rem",
            boxShadow: "unset",
            "& .smart-image.custom-icon.promo-icon-large": {
              position: "unset",
              top: "unset",
              left: "unset",
              width: "19rem",
              height: "11rem",
              "screen and (max-width: 1400px)": {},
            },
            "& .promotion-item-text": {
              "& h2": {
                color: "#fff !important",
                fontFamily: "LexendDeca-Bold",
                fontWeight: "bold",
                fontSize: "2rem",
                letterSpacing: "0.03em",
                lineHeight: "115%",
              },
              "& p": {
                fontFamily: "Inter-Medium",
                fontWeight: "normal",
                fontSize: "1.4rem",
                lineHeight: "150%",
                margin: "unset",
              },
            },
          },
      },
    },

    ".live-board .promotion-item .smart-image.custom-icon.promo-icon-large": {
      position: "absolute",
      top: "5rem",
      left: "0",
      width: "25%",
    },

    ".live-board-mobile .items-view-container": {
      borderTop: "none !important",
    },

    ".live-board .promotion-item .promotion-item-text p": {
      color: "#FFFFFF",
      fontFamily: "Inter-Medium",
      fontWeight: "normal",
      fontSize: "1.4rem",
      lineHeight: "150%",
      margin: "0 23rem",
    },
    // ".live-board .promotion-item .promotion-item-text h2": {
    //   color: "#FF8426 !important",
    //   fontFamily: "Lexend Deca",
    //   fontWeight: "bold",
    //   fontSize: "2.6rem",
    //   lineHeight: "125%",
    //   margin: "0 23rem",
    // },
    "@media screen and (max-width: 1400px)": {
      ".live-board .promotion-item .smart-image.custom-icon.promo-icon-large :not(.promo-area-3)":
        {
          width: "20%",
        },
    },
    "@media screen and (max-width: 980px)": {
      ".live-event-header": {
        maxWidth: "fit-content !important",
      },
    },
    "@media screen and (max-width: 768px)": {
      ".live-board .board-content-container": {
        backgroundColor: "#353944",
      },
      ".live-board .promotion-area-container": {
        padding: "2rem 0",
      },
      ".live-board .promotion-area-container .promotion-area-text p": {
        margin: "3rem 0",
        lineHeight: "5rem",
      },
      ".live-board .promotion-item .promotion-item-text p": {
        margin: "0 3rem",
      },
      ".live-board .promotion-item .promotion-item-text h2": {
        margin: "0 3rem",
      },
      ".live-board .promotion-item .smart-image.custom-icon.promo-icon-large": {
        position: "inherit",
        width: "100%",
      },
      ".live-event-stream-container": {
        width: "90% !important",
      },
    },
  },
});

function Styles() {
  useGlobalStyle();

  return null;
}

function mountHeader(e) {
  // console.debug("Header mouting", e);
  const liveEventHeader = document.querySelector("div.live-event-header");
  if (liveEventHeader) {
    ReactDOM.render(
      <React.StrictMode>
        <DataProvider>
          <Styles />
          <ScrollToTop
            smooth
            color="#353944"
            style={{
              width: "50px",
              height: "50px",
              right: "20px",
              bottom: "20px",
            }}
            top={100}
          />
          <Header />
        </DataProvider>
      </React.StrictMode>,
      liveEventHeader
    );
  } else {
    if (e.detail !== "FirstLoad") {
      // console.warn(
      //   "liveEventHeader not found in DOM, expected div.live-event-header to be on DOM"
      // );
    }
  }
}

function mountItems(e) {
  // console.debug("Items mouting", e);
  const itemsContainer = document.querySelector(
    "section.items-view-container "
  );
  if (itemsContainer) {
    itemsContainer.id = "items-view-container";
    ReactDOM.render(
      <React.StrictMode>
        <DataProvider>
          <Items />
        </DataProvider>
      </React.StrictMode>,
      itemsContainer
    );
  } else {
    if (e.detail !== "FirstLoad") {
      // console.warn(
      //   "itemsContainer not found in DOM, expected section.items-view-container to be on DOM"
      // );
    }
  }
}

function mountSocialMediaIcons(event) {
  // Clean icons if present
  if (document.querySelector(".share-icons"))
    document.querySelector(".share-icons").remove();

  // Check for existing dom element to append social icons
  const itemViewer = document.querySelector(".item-viewer");
  const container = document.querySelector(
    ".item-content-wrapper.current-item"
  );
  const item = event.detail.item;

  if (itemViewer && container) {
    let temp = document.createElement("div");
    temp.style.padding = "10px";
    temp.style.display = "flex";
    temp.style.flexDirection = "column";
    temp.style.position = "fixed";
    temp.style.right = "10px";
    temp.style.background = "white";
    temp.style.top = "calc(50% - 120px)";

    temp.classList.add("share-icons");
    temp.style.padding = "10px";
    temp.style.textAlign = "center";

    ReactDOM.render(
      <React.StrictMode>
        <TwitterShareButton title={item.name} url={window.location.href}>
          <TwitterIcon size={32} round={false} />
        </TwitterShareButton>
        <LinkedinShareButton title={item.name} url={window.location.href}>
          <LinkedinIcon size={32} round={false} />
        </LinkedinShareButton>
      </React.StrictMode>,
      temp
    );

    container.insertAdjacentElement("afterend", temp);
  }
}

window.addEventListener("Folloze.liveEventMounted", mountHeader);
window.addEventListener("Folloze.itemsContentMounted", mountItems);
window.addEventListener("Folloze.itemViewerLoaded", mountSocialMediaIcons);

function scrollToItemsViewContainer() {
  let tries = 0;
  const scroll = () => {
    const section = document.querySelector("section.items-view-container");
    const ready = document.readyState === "complete";
    if (section && ready) {
      setTimeout(() => {
        section.scrollIntoView();
      }, 1500);
    } else {
      tries++;
      if (tries < 50) {
        setTimeout(() => {
          scroll();
        }, 500);
      }
    }
  };
  scroll();
}

function mountStyles() {
  if (document.querySelector("footer")) {
    document.querySelector("footer").style.cssText =
      "display: block !important";
  }
}

if (document.readyState === "complete") {
  mountStyles();
} else {
  window.addEventListener("load", mountStyles);
}

if (window?.location?.hash === "#content") {
  scrollToItemsViewContainer();
}
